import { ArrowDropDown, ArrowRight, Folder, FolderSpecial, InsertDriveFile } from '@mui/icons-material';
import { Button, Checkbox, Menu, MenuItem, Typography, useTheme } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { CopyCutPasteType, FileDirectoryDTO } from '../../../../ApiOld/ApiServerVov';
import { useTranslation } from 'react-i18next';
import DeleteDialog from '../../../Shared/Layouts/DeleteDialog';
import { APIOldBuildingsClient } from '../../../../ApiOld/ApiOldBuildingsClient';
import './EmployeeDocumentTreeScene.css'
import { FileType, UploadFileDC, useUploadFileStore } from '../../../../Contexts/UploadFileContext';
import { getFilesFromDataTransferItems } from 'datatransfer-files-promise';
import { ContainsFolder } from '../../../Shared/Functions/ContainsFolder';
import CircularProgressDialog from '../../../Shared/CircularProgressDialog';
import { useEmployeesPermissionContext } from '../../../../Contexts/Permissions/EmployeesPermissionContext';
import { useApi } from '../../../../ApiOld/Api/useApi';
import { CopyCutPasteEmployeeFileRequest, CreateEmployeeFilesFromPathsRequest, DeleteEmployeeFileRequest, EmployeesVovClient } from '../../../../ApiOld/Api/ApiServerVov';
import EmployeeCreateFolderDialog from './EmployeeCreateFolderDialog';
import { CopyPasteEmployeeContext } from './Contexts/CopyPasteEmployeeContext';

interface EmployeeDocumentFileSceneProps {
    files: FileDirectoryDTO[];
    employeeId: number;
    selected?: FileDirectoryDTO;
    onSelect: (data: any) => void;
    onRefresh: () => void;
    setFiles: React.Dispatch<React.SetStateAction<FileDirectoryDTO[] | null>>;
}

export default function EmployeeDocumentFileScene(props: EmployeeDocumentFileSceneProps) {
    const { onSelect, onRefresh, files, selected, employeeId, setFiles } = props;
    const { t, i18n } = useTranslation();
    const [deleteDialogOpen, setDeleteDialogOpen] = React.useState(false);
    const [createDialogOpen, setCreateDialogOpen] = React.useState(false);
    const [copyCutPasteType, setCopyCutPasteType] = React.useState<CopyCutPasteType>();
    const [copyCutFolderId, setCopyCutFolderId] = React.useState<number>();
    const [createFolderDialogOpen, setCreateFolderDialogOpen] = React.useState(false);
    const theme = useTheme();
    const { uploadingFiles, addFile, uploadEmployeeFiles } = useUploadFileStore();

    const { permissions, reloadPermissions } = useEmployeesPermissionContext();
    const { authorizedApi } = useApi(EmployeesVovClient);

    useEffect(() => {
        if (!permissions)
            reloadPermissions();
    }, [reloadPermissions]);

    const [contextMenu, setContextMenu] = React.useState<{
        mouseX: number;
        mouseY: number;
    } | null>(null);

    const handleContextMenu = (event: React.MouseEvent, data: FileDirectoryDTO) => {
        event.preventDefault();
        event.stopPropagation();
        onSelect(data);
        setContextMenu(
            contextMenu === null
                ? {
                    mouseX: event.clientX + 2,
                    mouseY: event.clientY - 6
                }
                : // repeated contextmenu when it is already open closes it with Chrome 84 on Ubuntu
                // Other native context menus might behave different.
                // With this behavior we prevent contextmenu from the backdrop to re-locale existing context menus.
                null
        );
    };

    const handleCloseContextMenu = () => {
        setContextMenu(null);
    };

    useEffect(() => {
        //console.log('a:', selected);
        console.log('b:', files);
    }, [files]);

    function onDelete() {
        if (selected && selected?.id)
            authorizedApi.deleteEmployeeFile(new DeleteEmployeeFileRequest({ documentId: selected.id })).then(p => {
                setDeleteDialogOpen(false);
                onRefresh();
            });
    }

    const FileTreeView = ({ files }) => (
        <div style={{ maxHeight: '90%', minHeight: '120px', overflow: 'auto' }}>
            {files !== null &&
                files.map((file, index) => (
                    <FileNode key={'key' + index} file={file} setFiles={setFiles} setCopyCutFolderId={setCopyCutFolderId} setCopyCutPasteType={setCopyCutPasteType} index={index} level={1} />
                ))}
        </div>
    );

    const FileNode = (props) => {
        const { file, setFiles, index, level } = props;
        const contextValue = React.useContext(CopyPasteEmployeeContext);

        const { authorizedApi } = useApi(EmployeesVovClient);

        /* useEffect(() => {
        }, [contextValue]); */

        const toggleExpanded = (files: FileDirectoryDTO[], fileId: number): FileDirectoryDTO[] => {
            return files.map((item) => {
                if (item.id === fileId) {
                    return new FileDirectoryDTO({ ...item, isExpanded: !item.isExpanded });
                } else if (item.children && item.children.length > 0) {
                    return new FileDirectoryDTO({ ...item, children: toggleExpanded(item.children, fileId) });
                }
                return item;
            });
        };

        const handleToggleExpand = (e: any, fileId: number) => {
            e.preventDefault(); e.stopPropagation();
            setFiles((prev) => (prev ? toggleExpanded(prev, fileId) : prev));
        };

        const hasChildren = () => {
            return file && file.children && file.children.length > 0;
        }

        const [isDragging, setIsDragging] = useState(false);
        const handleDragEnter = useCallback((event: React.DragEvent<HTMLDivElement>) => {
            event.preventDefault();
            event.stopPropagation();
            setIsDragging(true);
        }, []);

        const handleDragOver = useCallback((event: React.DragEvent<HTMLDivElement>) => {
            event.preventDefault();
            event.stopPropagation();
            setIsDragging(true);
        }, []);

        const handleDragLeave = useCallback(() => {
            setIsDragging(false);
        }, []);

        const handlePaste = useCallback((targetFileId: number) => {
            if (contextValue !== null && contextValue.copyPasteId && targetFileId && contextValue.copyCutType !== undefined && contextValue.copyCutType !== null) {
                authorizedApi.copyCutPasteEmployeeFile(new CopyCutPasteEmployeeFileRequest({ sourceEmployeeDocumentId: contextValue.copyPasteId, targetEmployeeDocumentId: targetFileId, type: contextValue.copyCutType as CopyCutPasteType, documentFiledIds: [] })).then(p => {
                    onRefresh();
                });
            }
        }, [onRefresh, contextValue]);


        const handlePasteFiles = useCallback((targetFileId: number) => {
            if (contextValue !== null && contextValue.copyPasteFileIds && targetFileId && contextValue.copyCutType !== undefined && contextValue.copyCutType !== null) {
                authorizedApi.copyCutPasteEmployeeFile(new CopyCutPasteEmployeeFileRequest({ sourceEmployeeDocumentId: undefined, targetEmployeeDocumentId: targetFileId, type: contextValue.copyCutType as CopyCutPasteType, documentFiledIds: contextValue.copyPasteFileIds })).then(p => {
                    onRefresh();
                });
            }
        }, [onRefresh, contextValue]);

        const handleDrop = useCallback(
            async (event: React.DragEvent<HTMLDivElement>) => {
                event.preventDefault();
                event.stopPropagation();
                setIsDragging(false);

                const { files, types } = event.dataTransfer;
                if (files.length > 0) {
                    let hasFolder = ContainsFolder(event);

                    if (hasFolder) {
                        var allFiles = await getFilesFromDataTransferItems(event.dataTransfer.items);
                        //let filesObject = await fileListToObject(files);
                        setCreateFolderDialogOpen(true);
                        authorizedApi.createEmployeeFilesFromPaths(new CreateEmployeeFilesFromPathsRequest({ employeeId: employeeId, parentDocumentId: file.id, paths: allFiles.map(p => (p as any).filepath) })).then(p => {
                            setCreateFolderDialogOpen(false);
                            onRefresh();
                            for (let i = 0; i < allFiles.length; i++) {
                                addFile(new UploadFileDC(allFiles[i], false, false, file.id, true, (allFiles[i] as any).filepath, undefined, FileType.Employees));
                            }
                            uploadEmployeeFiles();
                        });
                    }
                    else {
                        for (let i = 0; i < files.length; i++) {
                            addFile(new UploadFileDC(files[i], false, false, file.id, true, '', undefined, FileType.Employees));
                        }
                        uploadEmployeeFiles();
                    }
                }
            },
            []
        );

        if (file)
            return (
                <div key={'key' + file.id} onClick={(e) => { e.preventDefault(); e.stopPropagation(); onSelect(file) }} onContextMenu={(e) => { handleContextMenu(e, file) }} >
                    <div style={{
                        display: 'flex',
                        border: isDragging ? '2px dashed' : '0px solid',
                        borderColor: isDragging ? theme.palette.text.primary : 'white',
                        cursor: 'pointer',
                    }}
                        onDragEnter={handleDragEnter}
                        onDragOver={handleDragOver}
                        onDragLeave={handleDragLeave}
                        onDrop={handleDrop}
                        className={`selectable ${selected && selected.id === file.id ? 'selected' : ''}`} >
                        {hasChildren() && <div style={{ color: 'black' }}><Button size='small' onClick={(e) => handleToggleExpand(e, file.id)}>
                            {!file.isExpanded && <ArrowRight htmlColor='black' />}
                            {file.isExpanded && <ArrowDropDown htmlColor='black' />}
                        </Button></div>}
                        {!hasChildren() && <div style={{ width: '64px', background: 'white' }}>

                        </div>}
                        <div style={{ display: 'flex', marginTop: '4px', paddingTop: '2px', cursor: 'context-menu'/* , marginLeft: '-16px' */ }}>
                            {file.isDirectory ? <Folder color='primary' /> : <FolderSpecial color='primary' />}
                            <Typography sx={{ marginLeft: '8px' }}>{file.name}</Typography>
                        </div >

                        <Menu
                            open={contextMenu !== null}
                            onClose={handleCloseContextMenu}
                            anchorReference="anchorPosition"
                            anchorPosition={
                                contextMenu !== null
                                    ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                                    : undefined
                            }
                        >
                            <MenuItem onClick={(e) => { e.preventDefault(); e.stopPropagation(); setCreateDialogOpen(true); handleCloseContextMenu(); }}>{t('files.createFolder')}</MenuItem>
                            <MenuItem disabled={!selected?.parent} onClick={(e) => { e.preventDefault(); e.stopPropagation(); setDeleteDialogOpen(true); handleCloseContextMenu(); }}>{t('files.deleteFolder')}</MenuItem>
                            <hr></hr>
                            <MenuItem onClick={(e) => {
                                e.preventDefault(); e.stopPropagation();
                                contextValue?.setCopyPasteId(selected?.id!);
                                contextValue?.setCopyCutType(CopyCutPasteType.Copy);
                                handleCloseContextMenu();
                            }}>{t('files.copyFolder')}</MenuItem>
                            <MenuItem onClick={(e) => {
                                e.preventDefault(); e.stopPropagation();
                                contextValue?.setCopyPasteId(selected?.id!);
                                contextValue?.setCopyCutType(CopyCutPasteType.Cut);
                                handleCloseContextMenu();
                            }}>{t('files.cutFolder')}</MenuItem>
                            <MenuItem disabled={contextValue === null || contextValue.copyPasteId === null || selected === undefined} onClick={(e) => {
                                e.preventDefault(); e.stopPropagation();
                                if (selected && selected?.id && contextValue?.copyPasteId)
                                    handlePaste(selected.id);
                                console.log(selected, contextValue?.copyPasteId);
                                handleCloseContextMenu();
                            }}>{t('files.pasteFolder')}</MenuItem>
                            <MenuItem disabled={contextValue === null || contextValue.copyPasteFileIds === null || contextValue.copyPasteFileIds.length === 0 || selected === undefined} onClick={(e) => {
                                e.preventDefault(); e.stopPropagation();
                                if (selected && selected?.id)
                                    handlePasteFiles(selected.id);
                                handleCloseContextMenu();
                            }}>{t('files.pasteFile')}</MenuItem>
                        </Menu>
                    </div>
                    {file.isExpanded && (
                        <div style={{ marginLeft: 20 + 'px' }}>
                            {file.children &&
                                file.children.map((child, i) => (
                                    <FileNode key={i} file={child} setFiles={setFiles} setCopyCutFolderId={setCopyCutFolderId} setCopyCutPasteType={setCopyCutPasteType} index={i} level={level + 1} />
                                ))}
                        </div>
                    )}
                </div>
            );
        else
            return <div></div>
    };

    if (files && files.length > 0)
        return <div>
            <FileTreeView files={files} />
            <DeleteDialog data={selected} onDeleteAgree={onDelete} onClose={() => setDeleteDialogOpen(false)} open={deleteDialogOpen} />
            <EmployeeCreateFolderDialog open={createDialogOpen} employeeId={employeeId} parentId={selected?.id} onClose={() => { setCreateDialogOpen(false); onRefresh(); }} />
            <CircularProgressDialog open={createFolderDialogOpen} onClose={() => setCreateFolderDialogOpen(true)} title={t('creatingFolderStructure')} />
        </div>;
    else
        return <div></div>;
}
